<template>
  <section class="app-main">
    <template>
      <keep-alive key="keep-alive">
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </template>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  components: {},
  computed: {},
};
</script>

<style scoped>
.app-main {
  height: 100%;
  position: relative;
  background: var(--themeBgc);
  overflow-x: hidden;
  overflow: auto;
}
.app-main-noheader {
  height: calc(100vh - 60px);
}
.app-main::-webkit-scrollbar {
  width: 0;
}
.fixed-header + .app-main {
  padding-top: 50px;
}

.contact-container {
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 999;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
